import pick from 'lodash/pick';

import { types as sdkTypes, createImageVariantConfig } from '../../util/sdkLoader';
import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { apiBaseUrl, transactionLineItems } from '../../util/api';
import * as log from '../../util/log';
import { denormalisedResponseEntities } from '../../util/data';
import { findNextBoundary, getStartOf, monthIdString } from '../../util/dates';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
} from '../../util/urlHelpers';
import { getProcess, isBookingProcessAlias } from '../../transactions/transaction';
import { fetchCurrentUser, fetchCurrentUserHasOrdersSuccess } from '../../ducks/user.duck';
import { fetchfavouriteListing } from '../SearchPage/SearchPage.duck';
import axios from 'axios';

const { UUID } = sdkTypes;

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/ListingPage/SET_INITIAL_VALUES';

export const SHOW_LISTING_REQUEST = 'app/ListingPage/SHOW_LISTING_REQUEST';
export const SHOW_LISTING_ERROR = 'app/ListingPage/SHOW_LISTING_ERROR';

export const FETCH_REVIEWS_REQUEST = 'app/ListingPage/FETCH_REVIEWS_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'app/ListingPage/FETCH_REVIEWS_SUCCESS';
export const FETCH_REVIEWS_ERROR = 'app/ListingPage/FETCH_REVIEWS_ERROR';

export const FETCH_TIME_SLOTS_REQUEST = 'app/ListingPage/FETCH_TIME_SLOTS_REQUEST';
export const FETCH_TIME_SLOTS_SUCCESS = 'app/ListingPage/FETCH_TIME_SLOTS_SUCCESS';
export const FETCH_TIME_SLOTS_ERROR = 'app/ListingPage/FETCH_TIME_SLOTS_ERROR';

export const FETCH_LINE_ITEMS_REQUEST = 'app/ListingPage/FETCH_LINE_ITEMS_REQUEST';
export const FETCH_LINE_ITEMS_SUCCESS = 'app/ListingPage/FETCH_LINE_ITEMS_SUCCESS';
export const FETCH_LINE_ITEMS_ERROR = 'app/ListingPage/FETCH_LINE_ITEMS_ERROR';

export const SEND_INQUIRY_REQUEST = 'app/ListingPage/SEND_INQUIRY_REQUEST';
export const SEND_INQUIRY_SUCCESS = 'app/ListingPage/SEND_INQUIRY_SUCCESS';
export const SEND_INQUIRY_ERROR = 'app/ListingPage/SEND_INQUIRY_ERROR';

const TIMEZONE_FETCH_SUCCESS = 'app/ListingPage/TIMEZONE_FETCH_SUCCESS';

const LISTING_ID_SUCCESS_FROM_URL = 'app/ListingPage/LISTING_ID_SUCCESS_FROM_URL';

// ================ Reducer ================ //

const initialState = {
  id: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  monthlyTimeSlots: {
    // '2022-03': {
    //   timeSlots: [],
    //   fetchTimeSlotsError: null,
    //   fetchTimeSlotsInProgress: null,
    // },
  },
  lineItems: null,
  fetchLineItemsInProgress: false,
  fetchLineItemsError: null,
  sendInquiryInProgress: false,
  sendInquiryError: null,
  inquiryModalOpenForListingId: null,
  listingTimeZone: null,
  listingIdFormUrl: null,
};

const listingPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case SHOW_LISTING_REQUEST:
      return { ...state, id: payload.id, showListingError: null };
    case SHOW_LISTING_ERROR:
      return { ...state, showListingError: payload };

    case FETCH_REVIEWS_REQUEST:
      return { ...state, fetchReviewsError: null };
    case FETCH_REVIEWS_SUCCESS:
      return { ...state, reviews: payload };
    case FETCH_REVIEWS_ERROR:
      return { ...state, fetchReviewsError: payload };

    case FETCH_TIME_SLOTS_REQUEST: {
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [payload]: {
          ...state.monthlyTimeSlots[payload],
          fetchTimeSlotsError: null,
          fetchTimeSlotsInProgress: true,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_SUCCESS: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          timeSlots: payload.timeSlots,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_ERROR: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          fetchTimeSlotsError: payload.error,
        },
      };
      return { ...state, monthlyTimeSlots };
    }

    case FETCH_LINE_ITEMS_REQUEST:
      return { ...state, fetchLineItemsInProgress: true, fetchLineItemsError: null };
    case FETCH_LINE_ITEMS_SUCCESS:
      return { ...state, fetchLineItemsInProgress: false, lineItems: payload };
    case FETCH_LINE_ITEMS_ERROR:
      return { ...state, fetchLineItemsInProgress: false, fetchLineItemsError: payload };

    case SEND_INQUIRY_REQUEST:
      return { ...state, sendInquiryInProgress: true, sendInquiryError: null };
    case SEND_INQUIRY_SUCCESS:
      return { ...state, sendInquiryInProgress: false };
    case SEND_INQUIRY_ERROR:
      return { ...state, sendInquiryInProgress: false, sendInquiryError: payload };

    case TIMEZONE_FETCH_SUCCESS:
      return { ...state, listingTimeZone: payload };
    case LISTING_ID_SUCCESS_FROM_URL:
      return {
        ...state,
        listingIdFormUrl: payload,
      };
    default:
      return state;
  }
};

export default listingPageReducer;

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

export const showListingRequest = id => ({
  type: SHOW_LISTING_REQUEST,
  payload: { id },
});

export const showListingError = e => ({
  type: SHOW_LISTING_ERROR,
  error: true,
  payload: e,
});

export const fetchReviewsRequest = () => ({ type: FETCH_REVIEWS_REQUEST });
export const fetchReviewsSuccess = reviews => ({ type: FETCH_REVIEWS_SUCCESS, payload: reviews });
export const fetchReviewsError = error => ({
  type: FETCH_REVIEWS_ERROR,
  error: true,
  payload: error,
});

export const fetchTimeSlotsRequest = monthId => ({
  type: FETCH_TIME_SLOTS_REQUEST,
  payload: monthId,
});
export const fetchTimeSlotsSuccess = (monthId, timeSlots) => ({
  type: FETCH_TIME_SLOTS_SUCCESS,
  payload: { timeSlots, monthId },
});
export const fetchTimeSlotsError = (monthId, error) => ({
  type: FETCH_TIME_SLOTS_ERROR,
  error: true,
  payload: { monthId, error },
});

export const fetchLineItemsRequest = () => ({ type: FETCH_LINE_ITEMS_REQUEST });
export const fetchLineItemsSuccess = lineItems => ({
  type: FETCH_LINE_ITEMS_SUCCESS,
  payload: lineItems,
});
export const fetchLineItemsError = error => ({
  type: FETCH_LINE_ITEMS_ERROR,
  error: true,
  payload: error,
});

export const sendInquiryRequest = () => ({ type: SEND_INQUIRY_REQUEST });
export const sendInquirySuccess = () => ({ type: SEND_INQUIRY_SUCCESS });
export const sendInquiryError = e => ({ type: SEND_INQUIRY_ERROR, error: true, payload: e });

export const timeZoneFetchSuccess = payload => ({ type: TIMEZONE_FETCH_SUCCESS, payload });
export const fetchListingIdFromUrl = id => ({ type: LISTING_ID_SUCCESS_FROM_URL, payload: id });

// ================ Thunks ================ //

export const showListing = (listingId, config, isOwn = false) => (dispatch, getState, sdk) => {
  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  dispatch(showListingRequest(listingId));
  dispatch(fetchCurrentUser());
  const params = {
    id: listingId,
    include: ['author', 'author.profileImage', 'images', 'currentStock'],
    'fields.image': [
      'variants.default',
      // Scaled variants for large images
      'variants.scaled-small',
      'variants.scaled-medium',
      'variants.scaled-large',
      'variants.scaled-xlarge',

      // Cropped variants for listing thumbnail images
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
      `variants.${variantPrefix}-4x`,
      `variants.${variantPrefix}-6x`,

      // Social media
      'variants.facebook',
      'variants.twitter',

      // Avatars
      'variants.square-small',
      'variants.square-small2x',
    ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-4x`, 1600, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-6x`, 2400, aspectRatio),
  };

  const show = isOwn ? sdk.ownListings.show(params) : sdk.listings.show(params);

  return show
    .then(data => {
      const listingFields = config?.listing?.listingFields;
      const sanitizeConfig = { listingFields };
      dispatch(addMarketplaceEntities(data, sanitizeConfig));
      return data;
    })
    .catch(e => {
      dispatch(showListingError(storableError(e)));
    });
};

export const fetchReviews = listingId => (dispatch, getState, sdk) => {
  dispatch(fetchReviewsRequest());
  return sdk.reviews
    .query({
      listing_id: listingId,
      state: 'public',
      include: ['author', 'author.profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    })
    .then(response => {
      const reviews = denormalisedResponseEntities(response);
      dispatch(fetchReviewsSuccess(reviews));
    })
    .catch(e => {
      dispatch(fetchReviewsError(storableError(e)));
    });
};

const timeSlotsRequest = (params, timeZone) => (dispatch, getState, sdk) => {
  return sdk.timeslots.query(params).then(response => {
    dispatch(timeZoneFetchSuccess(timeZone));
    return denormalisedResponseEntities(response);
  });
};

export const fetchTimeSlots = (listingId, start, end, timeZone) => (dispatch, getState, sdk) => {
  const monthId = monthIdString(start, timeZone);

  dispatch(fetchTimeSlotsRequest(monthId));

  // The maximum pagination page size for timeSlots is 500
  const extraParams = {
    perPage: 500,
    page: 1,
  };

  return dispatch(timeSlotsRequest({ listingId, start, end, ...extraParams }, timeZone))
    .then(timeSlots => {
      dispatch(fetchTimeSlotsSuccess(monthId, timeSlots));
    })
    .catch(e => {
      dispatch(fetchTimeSlotsError(monthId, storableError(e)));
    });
};

export const sendInquiry = (listing, message) => (dispatch, getState, sdk) => {
  dispatch(sendInquiryRequest());
  const processAlias = listing?.attributes?.publicData?.transactionProcessAlias;
  if (!processAlias) {
    const error = new Error('No transaction process attached to listing');
    log.error(error, 'listing-process-missing', {
      listingId: listing?.id?.uuid,
    });
    dispatch(sendInquiryError(storableError(error)));
    return Promise.reject(error);
  }

  const listingId = listing?.id;
  const [processName, alias] = processAlias.split('/');
  const transitions = getProcess(processName)?.transitions;

  const bodyParams = {
    transition: transitions.INQUIRE,
    processAlias,
    params: { listingId },
  };
  return sdk.transactions
    .initiate(bodyParams)
    .then(response => {
      const transactionId = response.data.data.id;

      // Send the message to the created transaction
      return sdk.messages.send({ transactionId, content: message }).then(() => {
        dispatch(sendInquirySuccess());
        dispatch(fetchCurrentUserHasOrdersSuccess(true));
        return transactionId;
      });
    })
    .catch(e => {
      dispatch(sendInquiryError(storableError(e)));
      throw e;
    });
};

// Helper function for loadData call.
const fetchMonthlyTimeSlots = (dispatch, listing) => {
  const hasWindow = typeof window !== 'undefined';
  const attributes = listing.attributes;
  // Listing could be ownListing entity too, so we just check if attributes key exists
  const hasTimeZone =
    attributes && attributes.availabilityPlan && attributes.availabilityPlan.timezone;

  // Fetch time-zones on client side only.
  if (hasWindow && listing.id && hasTimeZone) {
    const tz = listing.attributes.availabilityPlan.timezone;
    const unitType = attributes?.publicData?.unitType;
    const timeUnit = unitType === 'hour' ? 'hour' : 'day';
    const nextBoundary = findNextBoundary(new Date(), timeUnit, tz);

    const nextMonth = getStartOf(nextBoundary, 'month', tz, 1, 'months');
    const nextAfterNextMonth = getStartOf(nextMonth, 'month', tz, 1, 'months');

    return Promise.all([
      dispatch(fetchTimeSlots(listing.id, nextBoundary, nextMonth, tz)),
      dispatch(fetchTimeSlots(listing.id, nextMonth, nextAfterNextMonth, tz)),
    ]);
  }

  // By default return an empty array
  return Promise.all([]);
};

export const fetchTransactionLineItems = ({ orderData, listingId, isOwnListing }) => dispatch => {
  dispatch(fetchLineItemsRequest());
  transactionLineItems({ orderData, listingId, isOwnListing })
    .then(response => {
      const lineItems = response.data;
      dispatch(fetchLineItemsSuccess(lineItems));
    })
    .catch(e => {
      dispatch(fetchLineItemsError(storableError(e)));
      log.error(e, 'fetching-line-items-failed', {
        listingId: listingId.uuid,
        orderData,
      });
    });
};
export const checkListingFromIdOrNot = url => async (dispatch, getState, sdk) => {
  const withoutAtSring = url?.slice(1);
  return axios
    .post(`${apiBaseUrl()}/api/listingDetails`, {
      linkValue: withoutAtSring,
      dataFetch: true,
    })
    .then(res => {
      const id = new UUID(res?.data?.data?.[0]?.id?.uuid);
      dispatch(fetchListingIdFromUrl(id));
      return id;
    })
    .catch(err => {
      console.log(err);
    });
};

// export const loadData = (params, search, config) => async dispatch => {
//   let listingId;

//   // Clear old line-items
//   dispatch(setInitialValues({ lineItems: null }));

//   if (params?.listingUrl) {
//     listingId = await dispatch(checkListingFromIdOrNot(params.listingUrl));
//   } else {
//     listingId = new UUID(params.id);
//   }

//   const ownListingVariants = [LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT];
//   if (ownListingVariants.includes(params.variant)) {
//     return dispatch(showListing(listingId, config, true));
//   }

//   return Promise.all([
//     dispatch(showListing(listingId, config)),
//     dispatch(fetchReviews(listingId)),
//     dispatch(fetchfavouriteListing()),
//   ]).then(response => {
//     const listing = response[0].data.data;
//     const transactionProcessAlias = listing?.attributes?.publicData?.transactionProcessAlias || '';
//     if (isBookingProcessAlias(transactionProcessAlias)) {
//       // Fetch timeSlots.
//       // This can happen parallel to loadData.
//       // We are not interested to return them from loadData call.
//       fetchMonthlyTimeSlots(dispatch, listing);
//     }
//     return response;
//   });
// };

// const getId = params => async (dispatch, getState, sdk) => {
//   // return new UUID(params.id);
//   return Promise.resolve(new UUID(params.id));

// };
// export const loadData = (params, search, config) => dispatch => {
//   // Clear old line-items
//   dispatch(setInitialValues({ lineItems: null }));

//   if (params.listingUrl) {
//    const listingIdPromise = dispatch(checkListingFromIdOrNot(params.listingUrl));
//     return listingIdPromise.then(listingId => {
//       const ownListingVariants = [
//         LISTING_PAGE_DRAFT_VARIANT,
//         LISTING_PAGE_PENDING_APPROVAL_VARIANT,
//       ];

//       if (ownListingVariants.includes(params.variant)) {
//         return dispatch(showListing(listingId, config, true));
//       }

//       return Promise.all([
//         dispatch(showListing(listingId, config)),
//         dispatch(fetchReviews(listingId)),
//         dispatch(fetchfavouriteListing()),
//       ]).then(response => {
//         const listing = response[0].data.data;
//         const transactionProcessAlias =
//           listing?.attributes?.publicData?.transactionProcessAlias || '';

//         if (isBookingProcessAlias(transactionProcessAlias)) {
//           // Fetch timeSlots (non-blocking)
//           fetchMonthlyTimeSlots(dispatch, listing);
//         }

//         return response[0];
//       });
//     });
//   } else {
//     const listingId = new UUID(params.id);
//     const ownListingVariants = [LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT];

//     if (ownListingVariants.includes(params.variant)) {
//       return dispatch(showListing(listingId, config, true));
//     }

//     return Promise.all([
//       dispatch(showListing(listingId, config)),
//       dispatch(fetchReviews(listingId)),
//       dispatch(fetchfavouriteListing()),
//     ]).then(response => {
//       const listing = response[0].data.data;
//       const transactionProcessAlias =
//         listing?.attributes?.publicData?.transactionProcessAlias || '';

//       if (isBookingProcessAlias(transactionProcessAlias)) {
//         // Fetch timeSlots (non-blocking)
//         fetchMonthlyTimeSlots(dispatch, listing);
//       }

//       return response[0];
//     });
//   }

// };
export const loadData = (params, search, config) => dispatch => {
  // Clear old line-items
  dispatch(setInitialValues({ lineItems: null }));

  const getListingId = async () => {
    if (params?.listingUrl) {
      return dispatch(checkListingFromIdOrNot(params.listingUrl));
    } else {
      return new UUID(params.id);
    }
  };

  const ownListingVariants = [LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT];

  const sessionListingIdStr =
    typeof window !== 'undefined' ? sessionStorage.getItem('publishedListingId') : null;

  if (sessionListingIdStr) {
    const sessionListingId = new UUID(sessionListingIdStr);
    dispatch(fetchListingIdFromUrl(sessionListingId));
    return dispatch(showListing(sessionListingId, config, false)).finally(() => {
      if (typeof window !== 'undefined') {
        sessionStorage.removeItem('publishedListingId');
      }
    });
  }

  return getListingId().then(listingId => {
    if (!listingId) {
      throw new Error('Listing ID could not be resolved.');
    }

    if (ownListingVariants.includes(params.variant)) {
      return dispatch(showListing(listingId, config, true));
    }

    return Promise.all([
      dispatch(showListing(listingId, config)),
      dispatch(fetchReviews(listingId)),
      dispatch(fetchfavouriteListing()),
    ]).then(response => {
      const listing = response[0].data.data;
      const transactionProcessAlias =
        listing?.attributes?.publicData?.transactionProcessAlias || '';

      if (isBookingProcessAlias(transactionProcessAlias)) {
        fetchMonthlyTimeSlots(dispatch, listing); // non-blocking
      }

      return response[0];
    });
  });
};
